import {useState} from 'react';

const useFilter = <T>(): [
  Partial<Record<keyof T, any>>,
  (payload: Partial<Record<keyof T, any>>[]) => void
] => {
  const [filter, setFilter] = useState<Partial<Record<keyof T, any>>>(
    {} as Partial<Record<keyof T, any>>
  );
  return [
    filter,
    (payload: Partial<Record<keyof T, any>>[]): void => {
      const updates = {...filter};
      payload.forEach(filter => {
        Object.keys(filter).forEach(key => {
          updates[key] = filter[key as any];
        });
      });
      setFilter(updates);
    },
  ];
};

export default useFilter;
